import { MANIFESTO } from "@/data/content";
import { Reveal, MaskedLines, Eyebrow } from "./Reveal";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative bg-brand-navy py-28 text-white lg:py-40">
    <div className="absolute right-0 top-0 h-[600px] w-[600px] rounded-full bg-brand-indigo/30 blur-[160px]" />
    <div className="relative mx-auto grid max-w-[1400px] gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal><Eyebrow n="02" label="Manifesto" light /></Reveal>
          <MaskedLines
            as="h2"
            inView
            delay={0.1}
            className="mt-6 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl"
            lines={["What we believe,", "written down."]}
          />
          <Reveal delay={0.3}>
            <p className="mt-8 max-w-md text-base leading-relaxed text-white/60 md:text-lg">
              Four principles that decide how we hire, how we work and how we measure ourselves — across every brand we launch.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        {MANIFESTO.map((c, i) => (
          <Reveal key={c.n} delay={0.05 * i} data-testid={`manifesto-chapter-${i + 1}`} className="group border-t border-white/10 py-12 last:border-b lg:py-16">
            <div className="grid gap-6 sm:grid-cols-12">
              <div className="font-mono text-sm tracking-[0.2em] text-brand-cyan sm:col-span-2">{c.n}</div>
              <div className="sm:col-span-10">
                <h3 className="font-display text-2xl font-semibold tracking-tight transition-transform duration-700 ease-out group-hover:translate-x-2 sm:text-3xl lg:text-4xl">{c.title}</h3>
                <p className="mt-5 max-w-xl text-sm leading-relaxed text-white/60 sm:text-base">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
